import { CalendarDays, CircleDot, ListTodo, Trash2, UserRound } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { formatError, useAuth } from "@/auth";
import { CommentThread } from "@/components/projects/CommentThread";
import { LeadPicker } from "@/components/projects/LeadPicker";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { DateField } from "@/components/DateField";

function Prop({ icon: Icon, label, children }) {
  return <div className="pj-prop"><span className="pj-prop-label"><Icon size={15} />{label}</span><div className="pj-prop-value">{children}</div></div>;
}

export function TodoPanel({ project, todo, lists, members, onClose, onSaved }) {
  const { user } = useAuth();
  const canLink = user?.role === "admin" || user?.modules?.includes("pipeline");
  const [form, setForm] = useState({ title: todo.title, notes: todo.notes || "", assignee_id: todo.assignee_id || "", due_date: todo.due_date || "", status: todo.status, list_id: todo.list_id });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const save = async () => {
    try { await api.patch(`/projects/${project.id}/todos/${todo.id}`, { ...form, assignee_id: form.assignee_id || null, due_date: form.due_date || null }); toast.success("Tâche enregistrée."); onSaved(); } catch (e) { toast.error(formatError(e.response?.data?.detail)); }
  };
  const remove = async () => {
    if (!window.confirm("Supprimer cette tâche et ses commentaires ?")) return;
    await api.delete(`/projects/${project.id}/todos/${todo.id}`); onSaved(); onClose();
  };
  const listName = lists.find((l) => l.id === form.list_id)?.name;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent aria-describedby={undefined} className="pj-dialog" data-testid="todo-panel">
        <DialogTitle className="sr-only">Tâche</DialogTitle>
        <p className="pj-crumb">{project.name}{listName && <> · {listName}</>}</p>
        <textarea className="pj-title-input" rows={1} value={form.title} onChange={set("title")} data-testid="todo-panel-title" />
        <div className="pj-props">
          <Prop icon={CircleDot} label="Statut">
            <select className={`pj-chip pj-chip-${form.status}`} value={form.status} onChange={set("status")} data-testid="todo-panel-status">{Object.entries(project.columns).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select>
          </Prop>
          <Prop icon={UserRound} label="Assignée à">
            <select className="pj-chip" value={form.assignee_id} onChange={set("assignee_id")} data-testid="todo-panel-assignee"><option value="">Personne</option>{members.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}</select>
          </Prop>
          <Prop icon={CalendarDays} label="Échéance"><DateField className="pj-chip" value={form.due_date} onChange={(v) => set("due_date")({ target: { value: v } })} testid="todo-panel-due" /></Prop>
          <Prop icon={ListTodo} label="Liste">
            <select className="pj-chip" value={form.list_id} onChange={set("list_id")} data-testid="todo-panel-list">{lists.map((l) => <option key={l.id} value={l.id}>{l.name}</option>)}</select>
          </Prop>
        </div>
        {canLink && <LeadPicker projectId={project.id} todoId={todo.id} initial={todo.leads} onSaved={onSaved} />}
        <textarea className="pj-notes" rows={3} placeholder="Ajouter une description…" value={form.notes} onChange={set("notes")} data-testid="todo-panel-notes" />
        <div className="pj-row-actions">
          <button type="button" className="primary-button" onClick={save} data-testid="todo-panel-save">Enregistrer</button>
          <button type="button" className="secondary-button pj-danger" onClick={remove} data-testid="todo-panel-delete"><Trash2 size={15} />Supprimer</button>
        </div>
        <CommentThread projectId={project.id} targetType="todo" targetId={todo.id} members={members} />
      </DialogContent>
    </Dialog>
  );
}
